import { useState, useEffect } from 'react';
import { getMobileViewportInfo } from '@/utils/mobileUtils';

export const useMobileViewport = () => {
  const [viewportInfo, setViewportInfo] = useState(() => {
    if (typeof window !== 'undefined') {
      return getMobileViewportInfo();
    }
    return {
      isActualMobile: false,
      hasVisualViewport: false,
      viewportHeight: 0,
      windowHeight: 0,
      safeAreaBottom: false,
      userAgent: ''
    };
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const updateViewportInfo = () => {
      setViewportInfo(getMobileViewportInfo());
    };

    // Listen for visual viewport changes (mobile address bar show/hide)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateViewportInfo);
      window.visualViewport.addEventListener('scroll', updateViewportInfo);
    }

    // Fallback for regular window resize
    window.addEventListener('resize', updateViewportInfo);
    window.addEventListener('orientationchange', updateViewportInfo);

    // Initial update
    updateViewportInfo();

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', updateViewportInfo);
        window.visualViewport.removeEventListener('scroll', updateViewportInfo);
      }
      window.removeEventListener('resize', updateViewportInfo);
      window.removeEventListener('orientationchange', updateViewportInfo);
    };
  }, []);

  return viewportInfo;
};